import React from 'react';
import { OverlayViewF } from '@react-google-maps/api';
import { normalizeMapPosition } from '../utils/mapCoordinates';
import { formatStatus } from '../constants/workflowLabels';

/** Center callout above marker (not Google InfoWindow). */
function calloutPixelOffset(width, height) {
  return {
    x: -Math.round(width / 2),
    y: -height - 16,
  };
}

export function buildPermitCalloutContent(permit) {
  if (!permit) {
    return { title: 'Permit', lines: [] };
  }
  const loc = permit.alarmLocation || {};
  const address =
    permit.address ||
    [loc.street, loc.city, loc.state, loc.zipCode].filter(Boolean).join(', ');

  return {
    title: permit.type || permit.permitType || 'Permit',
    lines: [
      permit.description,
      address || null,
      permit.status ? `Status: ${formatStatus(permit.status)}` : null,
    ].filter(Boolean),
  };
}

/**
 * HTML permit details anchored on the map (OverlayView — stable, no InfoWindow).
 */
const MapPermitCallout = ({ position, title, lines = [], onClose }) => {
  const pos = normalizeMapPosition(position);
  if (!pos) return null;

  return (
    <OverlayViewF
      position={pos}
      mapPaneName="floatPane"
      getPixelPositionOffset={calloutPixelOffset}
    >
      <div
        className="rhs-map-callout"
        role="status"
        aria-live="polite"
        aria-label={title || 'Permit details'}
      >
        {onClose && (
          <button
            type="button"
            className="rhs-map-callout-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        )}
        {title && <div className="rhs-map-callout-title">{title}</div>}
        {lines.filter(Boolean).map((line, i) => (
          <p key={`${title}-${i}-${line}`} className="rhs-map-callout-line">
            {line}
          </p>
        ))}
      </div>
    </OverlayViewF>
  );
};

export default MapPermitCallout;
